<template>
  <div class="gmap-location-intention">
    <div class="gmap-location-intention__box">
      <header class="gmap-location-intention__box__header">
        <ui-button
          class="gmap-location-intention__box__header__close"
          @click.prevent="setCurrentLocation(null)"
          button="secondary"
          :label="$t('commons.buttons.close')"
          :icon-only="true"
          icon="close"
        />
        <div class="gmap-location-intention__box__header__marker">
          <marker-default
            class="gmap-location-intention__box__header__marker__img"
            :filters="filters"
            :current-value="location.source"
            :filtered-by-key="true"
            :is-competitor="!location.brand_status"
          />
        </div>
        <div class="gmap-location-intention__box__header__content">
          <div class="gmap-location-intention__box__header__content__title">
            {{ location.name }}
          </div>
          <div class="gmap-location-intention__box__header__content__subtitle">
            {{ location.primaryNaicsDescription }}
          </div>
        </div>
      </header>
      <div class="gmap-location-intention__box__container">
        <div class="gmap-location-intention__box__container__adress">
          <div>
            {{ location.street1 }}
          </div>
          <div>
            {{ location.postalCode }},
            {{ location.city }}
          </div>
          <div>
            {{ location.country }}
          </div>
        </div>
      </div>
      <div class="gmap-location-intention__box__container__url" v-if="location.website">
        <router-link class="gmap-location-intention__box__container__url__router" target="_blank" :to="urlWithProtocol">
          {{ $t('locationIntention.link') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import MarkerDefault from '@/components/Marker/Default.vue'
import UiButton from '@/components/UI/Button.vue'

export default {
  name: 'GmapLocationIntention',
  components: {
    MarkerDefault,
    UiButton,
  },
  props: {
    location: {
      type: Object,
      required: true,
    },
    source: {
      type: String,
      required: true,
    },
    filters: {
      type: Array,
      required: true,
    },
    settings: {
      type: Object,
      required: true,
    },
    distance: {
      type: Number,
      required: true,
    },
  },
  computed: {
    urlWithProtocol() {
      const url = this.location.website
      if (url.includes('//')) return url
      return `//${this.location.website}`
    },
  },
  methods: {
    ...mapActions({
      setCurrentLocation: 'data/setCurrentLocation',
    }),
  },
}
</script>

<style lang="scss" scoped>
.gmap-location-intention {
  @include wrapper(flex-start, $gutter-md);

  @media (min-width: $screen-sm) {
    right: initial;
    bottom: initial;
    width: calc(#{$gmap-sidebar-width-tablet} + #{$gutter-md} * 2);
  }

  @media (min-width: $screen-lg) {
    width: calc(#{$gmap-sidebar-width-desktop} + #{$gutter-md} * 2);
  }

  &__box {
    @include box;

    width: $gmap-sidebar-width-mobile;

    @media (min-width: $screen-sm) {
      width: $gmap-sidebar-width-tablet;
    }

    @media (min-width: $screen-lg) {
      width: $gmap-sidebar-width-desktop;
    }

    &__header {
      @include header;

      &__close {
        @include close('top');
      }

      &__marker {
        display: flex;
        position: relative;
        margin-right: 12px;
        width: 20px;

        &__img {
          width: 100%;

          @media (max-width: $screen-sm) {
            padding-top: 5px;
          }
        }
      }

      &__content {
        margin-right: 30px;
        &__title {
          @include title(1rem);

          display: -webkit-box;
          flex: 1;
          padding-bottom: 1px;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }

        &__subtitle {
          font-size: 0.8rem;
        }
      }
    }

    &__container {
      @include container;

      &__url {
        margin-bottom: $spacing-sm;
        display: flex;
        align-items: center;
        justify-content: center;

        &__router {
          transition: background-color $transition-duration-default $transition-effect-default;
          font-size: 1rem;
          text-decoration: none;
          color: $white;
          background-color: $generic-color-gtr;
          padding: 8px 16px;
          border-radius: 4px;
          text-transform: uppercase;
          &:hover {
            background-color: rgba($generic-color-gtr, 0.9);
          }
        }
      }
    }
  }
}
</style>
